module.exports = __webpack_public_path__ + "img/p2.bc41eaf7.png";